// eslint-disable
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import patternGenerator from '../../hooks/usePatternGenerator';
// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/border-randomizer.scss';

const propTypes = {
    seed: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    size: PropTypes.string,
    borders: PropTypes.object.isRequired, // eslint-disable-line
    borderClassName: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    seed: 4,
    size: null,
    borderClassName: null,
    className: null,
};

const BorderRandomizer = ({ seed, size, borders, borderClassName, className }) => {
    const randomSize = patternGenerator(seed, borders);
    const Border = borders[size || randomSize];
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Border
                className={classNames([
                    styles.border,
                    { [borderClassName]: borderClassName !== null },
                ])}
            />
        </div>
    );
};

BorderRandomizer.propTypes = propTypes;
BorderRandomizer.defaultProps = defaultProps;

export default BorderRandomizer;
